import { render, staticRenderFns } from "./DownloadPremiereExtensionButton.vue?vue&type=template&id=56e0a129&scoped=true&"
import script from "./DownloadPremiereExtensionButton.vue?vue&type=script&lang=js&"
export * from "./DownloadPremiereExtensionButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPremiereExtensionButton.vue?vue&type=style&index=0&id=56e0a129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0a129",
  null
  
)

export default component.exports